import {
  NAVIGATION_NEWS_BLOG_TESTS,
  NAVIGATION_NEWS_COMPARATIVE,
  NAVIGATION_NEWS_MOST_NEW,
  NAVIGATION_NEWS_TIPS,
  NAVIGATION_NEWS_TRENDS,
  NAVIGATION_NEWS_VIDEOS
} from './navigation'

export const subscriptionResponses = {
  201: {
    type: 'success',
    text: 'CARD_SUBSCRIPTION_MESSAGE_OK'
  },
  202: {
    type: 'success',
    text: 'CARD_SUBSCRIPTION_MESSAGE_OK',
    altText: 'CARD_SUBSCRIPTION_MESSAGE_VALIDATION_PENDING'
  },
  409: {
    type: 'info',
    text: 'CARD_SUBSCRIPTION_MESSAGE_EMAIL_EXISTS'
  },
  400: {
    type: 'error',
    text: 'CARD_SUBSCRIPTION_MESSAGE_INSERT_VALID_EMAIL'
  },
  424: {
    type: 'error',
    text: 'COMMON.SOMETHING_WENT_WRONG'
  },
  500: {
    type: 'error',
    text: 'COMMON.SOMETHING_WENT_WRONG'
  }
}

export const defaultSubscriptionResponse = subscriptionResponses['500']

export const NEWS_CATEGORIES_LABELS = {
  MAIN: 'portada',
  TESTS: 'pruebas',
  MOST_NEW: 'novedades',
  ACTUALITY: 'actualidad',
  COMPARISON: 'comparativas',
  VIDEOS: 'videos',
  TRENDS: 'tendencias',
  TIPS: 'consejos',
  RANKINGS: 'rankings'
}

export const newsCategories = [
  {
    id: 'news',
    label: NEWS_CATEGORIES_LABELS.MAIN,
    path: ''
  },
  {
    id: 'tests',
    label: NEWS_CATEGORIES_LABELS.TESTS,
    path: 'pruebas'
  },
  {
    id: 'newness',
    label: NEWS_CATEGORIES_LABELS.MOST_NEW,
    path: 'novedades'
  },
  {
    id: 'comparisons',
    label: NEWS_CATEGORIES_LABELS.COMPARISON,
    path: 'comparativas'
  },
  {
    id: 'videos',
    label: NEWS_CATEGORIES_LABELS.VIDEOS,
    path: 'videos'
  }
]

export const categoriesUrls = newsCategories.map(category => category.path)

/**
 * @exports hard_coded_brands_from_monolith
 */

export const SPECIAL_BRANDS = ['land rover', 'alfa romeo']

export const MAKES_WITH_HYPHENS = [
  {
    regex: /land(-|_)rover/,
    key: 'land-rover'
  },
  {
    regex: /mercedes(-|_)benz/,
    key: 'mercedes-benz'
  }
]

/**
 * @exports boolean condition used in getFormattedTagNewsSearchUseCase
 */
export const NEED_SPECIAL_FORMAT_TAG_TO_URL = true

export const ARTICLE_COMMENTS_ANCHOR = '#section_Opinions'
export const HAS_MOBILE_COMMENTS_PAGE_ENABLED = true
export const NEWSLETTER_SIDEBAR_ENABLED = false
export const NEWSLETTER_BANNER_ENABLED = true
export const NEWSLETTER_BODY_ENABLED = true

export const BREADCRUMBS_ROOT_LITERAL = 'BREADCRUMB_NEWS_LABEL_COCHES'
export const CATEGORIES_LISTING_URLS = {
  [NEWS_CATEGORIES_LABELS.COMPARISON]: NAVIGATION_NEWS_COMPARATIVE.url,
  [NEWS_CATEGORIES_LABELS.TIPS]: NAVIGATION_NEWS_TIPS.url,
  [NEWS_CATEGORIES_LABELS.MOST_NEW]: NAVIGATION_NEWS_MOST_NEW.url,
  [NEWS_CATEGORIES_LABELS.TESTS]: NAVIGATION_NEWS_BLOG_TESTS.url,
  [NEWS_CATEGORIES_LABELS.TRENDS]: NAVIGATION_NEWS_TRENDS.url,
  [NEWS_CATEGORIES_LABELS.VIDEOS]: NAVIGATION_NEWS_VIDEOS.url
}

export const MAX_RELATED_ADS = 8
export const HAS_RATING_ENABLED = true
export const SAVED_NEWS_EMPTY_CASE_IMAGE = 'images/illustrations/save-news-for-later-empty-case-coches.svg'
export const ARTICLE_CARD_IMAGE_WIDTH_L = 864
export const ARTICLE_CARD_IMAGE_WIDTH_M = 432
export const ARTICLE_CARD_IMAGE_WIDTH_S = 300
export const ARTICLE_BODY_IMAGE_WIDTH = 900
